import React from "react";
import { brandValues } from "../data/brandData";
import { BrandValue } from "../types/colors";
import "../styles/brandGuidelines.css";

const BrandValues = () => {
  return (
    <div className="brand-values">
      <h2>Brand Values</h2>
      <p>
        Our brand values are represented through our color choices, each
        symbolizing a core aspect of our identity.
      </p>
      <div className="values-grid">
        {brandValues.map((value: BrandValue, index: number) => (
          <div key={index} className="value-item">
            <div
              className="value-color"
              style={{ backgroundColor: value.color }}
            ></div>
            <h3 className="value-title">{value.title}</h3>
            <p className="value-desc">{value.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandValues;
